//* Libraries imports
import { useEffect, useState } from "react";
import { useParams, Outlet } from "react-router-dom";

//* Components Imports
import { TokenValidationScreen } from "./components/TokenValidationScreen";

//* Hooks Imports
import { useGetSale } from "@hooks/sales/queries/useGetSale";

//* Types
import type { ISaleOutputDTO } from "@/schemas/sales";

export function PaymentLayout() {
  const { id } = useParams();
  const queryGetSale = useGetSale(id, { refetchInterval: 10000 });
  const [isValidated, setIsValidated] = useState<boolean>(false);

  useEffect(() => {
    if (queryGetSale.data?.verificationToken) {
      const { token, expiresAt } = queryGetSale.data.verificationToken;
      const storedToken = sessionStorage.getItem(`sale_validated_${token}`);
      const expirationDate = new Date(expiresAt);
      const now = new Date();

      if (storedToken === "true" && now <= expirationDate) {
        setIsValidated(true);
      } else {
        setIsValidated(false);
        if (storedToken) {
          sessionStorage.removeItem(`sale_validated_${token}`);
        }
      }
    }
  }, [queryGetSale.data]);

  if (queryGetSale.isPending) {
    return (
      <div className="flex-1 flex items-center justify-center min-h-screen p-4">
        <div className="animate-spin rounded-full size-12 border-b-2 border-claroprimaria-01"></div>
      </div>
    );
  }

  if ((!isValidated || !queryGetSale.data) && id) {
    return (
      <TokenValidationScreen
        onSuccess={(token) => {
          setIsValidated(true);
          sessionStorage.setItem(`sale_validated_${token}`, "true");
        }}
      />
    );
  }
  localStorage.removeItem(id);

  return (
    <Outlet
      context={{
        sale: queryGetSale.data as ISaleOutputDTO | null,
        refetchSale: queryGetSale.refetch,
      }}
    />
  );
}
